import { ArrowRight, Phone } from "@phosphor-icons/react";
import Avatar from "./Avatar";

// Sticky top bar for the room — back button + peer avatar + name + presence
// + optional voice-call CTA. Kept as a pure presentational component; all
// call-state gating happens in the parent.
export default function RoomHeader({
  title, subtitle, otherTyping, otherProfile, conv, canCall, onBack, onStartCall,
}) {
  return (
    <header
      className="px-4 pb-3 shrink-0 z-30 text-right"
      style={{
        paddingTop: "calc(env(safe-area-inset-top, 0px) + 14px)",
        background:
          "linear-gradient(180deg, rgba(255,255,255,0.92) 0%, rgba(255,255,255,0.72) 60%, rgba(255,255,255,0) 100%)",
        backdropFilter: "blur(8px)",
        WebkitBackdropFilter: "blur(8px)",
      }}
    >
      <div className="flex items-center gap-3">
        <button
          type="button"
          onClick={onBack}
          className="w-10 h-10 rounded-full bg-white shadow-[0_2px_8px_rgba(10,25,47,0.10)] flex items-center justify-center active:scale-95 transition-transform shrink-0"
          data-testid="room-back"
          aria-label="رجوع"
        >
          <ArrowRight size={20} weight="bold" className="text-[#0A192F]" />
        </button>

        <Avatar name={title} size={38} avatarId={otherProfile?.avatar_id || ""} />

        <div className="flex-1 min-w-0">
          <div className="font-bold text-[15px] truncate text-[#0A192F]" data-testid="room-title">{title}</div>
          <div className="text-[11.5px] text-[#5A6470] truncate h-4">
            {otherTyping ? (
              <span className="inline-flex items-center gap-1 text-[#10B981]">
                <span className="w-1.5 h-1.5 rounded-full bg-[#10B981] animate-pulse" />
                يكتب الآن…
              </span>
            ) : subtitle}
          </div>
        </div>

        {otherProfile && conv?.kind === "dm" && canCall && (
          <button
            type="button"
            onClick={onStartCall}
            disabled={!canCall}
            className="w-10 h-10 rounded-full bg-gradient-to-br from-[#10B981] to-[#059669] text-white flex items-center justify-center active:scale-95 transition-transform shrink-0 shadow-[0_3px_10px_rgba(16,185,129,0.45)] disabled:opacity-50"
            data-testid="room-voice-call"
            aria-label="مكالمة صوتية"
          >
            <Phone size={18} weight="fill" />
          </button>
        )}
      </div>
    </header>
  );
}
